import { defineMessages } from 'react-intl'


export default defineMessages({
  session: {
    defaultMessage: 'session',
    id: 'storage-disclosure-row.session',
  },
})
